/**
 * A sketch of a document's first page from its outline: the headline, a band
 * of figures, a chart, the findings, in the order the document has them.
 *
 * Drawn from the list's outline alone, so it costs no extra request. A
 * document saved before outlines existed is sketched as plain text.
 */
import { ChartSketch } from "./DashboardPreview";
import { outlineLabels } from "./workspaceView";

const MAX_BLOCKS = 4;

function Block({ kind }: { kind: string }) {
  switch (kind) {
    case "headline":
      return (
        <span className="doc-block headline">
          <i className="strong" />
          <i />
          <i className="short" />
        </span>
      );
    case "kpi":
      return (
        <span className="doc-block kpi">
          <b />
          <b />
          <b />
        </span>
      );
    case "findings":
      return (
        <span className="doc-block findings">
          <i />
          <i />
          <i className="short" />
        </span>
      );
    default:
      return (
        <span className={`doc-block chart ${kind}`}>
          <ChartSketch chartType={kind} />
        </span>
      );
  }
}

export function DocumentPreview({ outline = [] }: { outline?: string[] }) {
  const blocks = outline.slice(0, MAX_BLOCKS);
  const labels = outlineLabels(outline);
  return (
    <div
      className="document-sketch"
      role="img"
      aria-label={labels.length ? `Holds ${labels.join(", ")}` : "Document"}
    >
      <div className="document-page">
        {blocks.length > 0
          ? blocks.map((kind, index) => <Block key={`${kind}-${index}`} kind={kind} />)
          : (
            <span className="doc-block findings">
              <i className="strong" />
              <i />
              <i />
              <i className="short" />
            </span>
          )}
      </div>
    </div>
  );
}
